export enum DatiqGraphCardChartLabel {
  Percent = 'percent',
  Dollar = 'dollar',
}
